import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
  makeStyles,
  Divider,
  DialogActions,
} from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'

import { selectSegmentation, selectSelectedSegments } from '~/selectors'
import { useLiterals } from '~/components/Literals'
import actions from '~/actions'

import SegmentTag from '../SegmentTag'

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 4,
    padding: 10,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fontSize: 14,
    lineHeight: 14,
    textTransform: 'none',
    height: 24,
    display: 'flex',
    gap: 4,
    flexWrap: 'nowrap',
  },
  textButton: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  rotate90: {
    rotate: '90deg',
  },
}))

const FilterIcon = (props) => {
  return (
    <SvgIcon width="12" height="12" viewBox="-2 -2 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99999 11.2533C8.02665 11.4533 7.95999 11.6667 7.80665 11.8067C7.54665 12.0667 7.12665 12.0667 6.86665 11.8067L4.19332 9.13333C4.03999 8.98 3.97332 8.77333 3.99999 8.58V5.16667L0.806653 1.08C0.579986 0.793333 0.63332 0.373333 0.919987 0.146667C1.04665 0.0533334 1.18665 0 1.33332 0H10.6667C10.8133 0 10.9533 0.0533334 11.08 0.146667C11.3667 0.373333 11.42 0.793333 11.1933 1.08L7.99999 5.16667V11.2533ZM2.69332 1.33333L5.33332 4.70667V8.38667L6.66665 9.72V4.7L9.30665 1.33333H2.69332Z"
        fill="#444444"
      />
    </SvgIcon>
  )
}

const SegmentationFilter = () => {
  const dispatch = useDispatch()
  const segmentation = useSelector(selectSegmentation)
  const selectedSegments = useSelector(selectSelectedSegments)
  const { getLiteral } = useLiterals()

  const classes = useStyle()
  const [open, setOpen] = useState(false)
  const hasSelectedSegment = !!selectedSegments.length

  const handleSelect = (segment) => () => {
    dispatch(actions.toggleSegment(segment))
  }

  const handleClearSelectedSegments = () => {
    dispatch(actions.clearSegments())
  }

  return (
    <>
      <Dialog aria-labelledby="filtro-categoria-lojas" open={open} onClose={() => setOpen(false)}>
        <DialogTitle id="filtro-categoria-lojas" style={{ paddingLeft: 27, paddingRight: 27 }}>
          {getLiteral('3015')}:
        </DialogTitle>
        <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
          <List>
            {Object.keys(segmentation || {})
              .sort()
              .map((segment) => (
                <ListItem
                  style={{ paddingLeft: 27, paddingRight: 27 }}
                  key={segment}
                  divider
                  button
                  onClick={handleSelect(segment)}
                >
                  <ListItemIcon>
                    <Checkbox
                      color="primary"
                      edge="start"
                      checked={selectedSegments.includes(segment) || false}
                      disableRipple
                      inputProps={{ 'aria-labelledby': `checkbox-label-${segment}` }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={`checkbox-label-${segment}`}
                    primary={<SegmentTag segment={segment} />}
                  ></ListItemText>
                </ListItem>
              ))}
          </List>
        </DialogContent>

        <DialogActions
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '16px 27px',
          }}
        >
          <Button style={{ textTransform: 'none' }} variant="contained" color="primary" onClick={() => setOpen(false)}>
            {getLiteral('3017')}
          </Button>
          <Button variant="text" className={classes.textButton} onClick={handleClearSelectedSegments}>
            {getLiteral('1788')}
          </Button>
        </DialogActions>
      </Dialog>

      <Box className={classes.root}>
        <Button
          onClick={() => setOpen(true)}
          style={{ height: 'fit-content' }}
          classes={{ label: classes.button }}
          variant="text"
          size="small"
          startIcon={<FilterIcon fontSize="16px" />}
          endIcon={<ChevronRight className={!hasSelectedSegment && classes.rotate90} />}
        >
          <Typography style={{ whiteSpace: 'nowrap' }}>{`${getLiteral('3015')}${
            hasSelectedSegment ? ':' : ''
          }`}</Typography>
          {hasSelectedSegment && <SegmentTag segment={selectedSegments[0]} />}
          <Typography>{selectedSegments.length > 1 && `+${selectedSegments.length - 1}`}</Typography>
        </Button>
      </Box>

      <Divider />
    </>
  )
}

export default SegmentationFilter
